<template lang='pug'>
.collection-container(v-if="!bookMarksLoading")
    userCard.user-container
    tabContainer
</template>

<script>
import { mapState } from 'vuex'
import userCard from './components/userCard'
import tabContainer from './components/tabContainer'

export default {
    name:'collection',
    data(){
        return {
            
        }
    },
    components:{
        userCard,tabContainer
    },
    async created() {
        this.$root.$emit('action',{name:this.$route.name})
    },
    computed:{
      ...mapState(['bookMarksLoading'])
    },
    methods:{
    }
}
</script>

<style scoped lang='less'>

.user-container{
    margin-bottom:1rem ;
}
</style>